// The users of every company marked Remove access in Victor's "Solsten users
// (Traits & Navigator)" sheet (Companies tab, as of 2026-11-02), lower case.
// Locked out by UpgradeOverlay; staging only for now (helpers.ts).
export const REMOVE_ACCESS_EMAILS: string[] = [
  'a.brieg@astragon.de',
  'a@high.rs',
  'abhroy@ea.com',
  'aconnor@zynga.com',
  'adrien@millionvictories.com',
  'aflynn@ea.com',
  'agata.rutkowska@huuugegames.com',
  'akrylov@scorewarrior.com',
  'alena@wolfgames.net',
  'alex@nightmarket.games',
  'alexander.malyavko@g5.com',
  'alexandra.danino@firebirdgames.com',
  'algibb@ea.com',
  'ali.sher@onepeloton.com',
  'alicja.truchel@huuugegames.com',
  'alon.altman@playstudios-il.com',
  'alusen@zynga.com',
  'amy.pantea@polyarcgames.com',
  'an.perez@draftkings.com',
  'ana.lopez@stillfront.com',
  'anahita.ejtehadi@innogames.com',
  'anastasiya.latyshava@huuugegames.com',
  'anders@dirtybit.no',
  'aneesh.aravind+2@sony.com',
  'aneesh.aravind@sony.com',
  'anissa.nehls@stillfront.com',
  'anissa@trailmixgames.com',
  'anna.gruzina@innogames.com',
  'anna.hoa-manh@huuugegames.com',
  'anne.marte@dirtybit.no',
  'annika.emmel@stillfront.com',
  'arkadiy.ragzin@g5.com',
  'arne.blumenberg@stillfront.com',
  'aronsogor@legodigitalplay.com',
  'arsubramanian@ea.com',
  'asilnikov@scorewarrior.com',
  'asmits@ea.com',
  'avernigora@scorewarrior.com',
  'aviv.zehavi@playstudios-il.com',
  'babakn@playstudios.com',
  'bahadir@cyphergames.com',
  'bailey.li@ea.com',
  'bart.chlebowski@liquidandgrit.com',
  'bbifulco@zynga.com',
  'becky@trailmixgames.com',
  'ben.ehlinger@cdm.lu',
  'benoit@millionvictories.com',
  'bethany@nightmarket.games',
  'brett.nowak@liquidandgrit.com',
  'brian.callan@zynga.com',
  'camila.oliveira@metacoregames.com',
  'carlos.guzman@stillfront.com',
  'carrie@liquidandgrit.com',
  'cbr@legodigitalplay.com',
  'celine.pasula@ubisoft.com',
  'chard@ea.com',
  'charlese.saballe@metacoregames.com',
  'chrisd@extradimension.games',
  'chrissie.klass@stillfront.com',
  'christian.casas@mythical.games',
  'christopher@trailmixgames.com',
  'chuzhang@zynga.com',
  'cla@legodigitalplay.com',
  'cloomislofland@ea.com',
  'd.hanaka@draftkings.com',
  'dadong@ea.com',
  'dan.stump@liquidandgrit.com',
  'daniel.serena@stillfront.com',
  'daniel.stolz@swr.de',
  'daniel@lootlabs.xyz',
  'dawid.hoa-manh@huuugegames.com',
  'ddetsaridis@havelii.com',
  'defne@cyphergames.com',
  'dennie@pocketworlds.com',
  'dennis@nightmarket.games',
  'desireel@playstudios.com',
  'diana.phan@playstudios.com',
  'dina.post@cdm.lu',
  'dmckibbin@ea.com',
  'dominika.stanczyk@huuugegames.com',
  'dtiwari@zynga.com',
  'efokin@scorewarrior.com',
  'elarsen@ea.com',
  'elif@cyphergames.com',
  'elina.adams@metacoregames.com',
  'eliza@signumgrowthcapital.com',
  'ella@dirtybit.no',
  'elle@wolfgames.net',
  'elliott@lootlabs.xyz',
  'em@nightmarket.games',
  'erik.pontiskoski@dodreams.com',
  'erlend@dirtybit.com',
  'estephan.campisi@liquidandgrit.com',
  'ethan@harmonygames.co',
  'eugenio.luciano@metacoregames.com',
  'ewa@trailmixgames.com',
  'fabian.moebius@westwing.de',
  'fabian.weiske@innogames.com',
  'fnicolaskim@ea.com',
  'fredrik@dirtybit.no',
  'g.grippo@astragon.de',
  'gbliss@ea.com',
  'ggarin@scorewarrior.com',
  'giuseppe.trapani@sony.com',
  'gpastucha@pixelfederation.com',
  'greg.eldridge@liquidandgrit.com',
  'gudmundur@1939games.com',
  'hanah@rewiredtx.com',
  'hanna.meyer@cdm.lu',
  'harri.hakala@metacoregames.com',
  'hburrows@ea.com',
  'heikki.joas@metacoregames.com',
  'henri.tani@metacoregames.com',
  'henri@1939games.com',
  'henrik.sarimo@metacoregames.com',
  'hrafnkell@1939games.com',
  'ian.abreau@liquidandgrit.com',
  'iida.oksanen@metacoregames.com',
  'ivana.petrovic@nanobit.com',
  'ivar@1939games.com',
  'ivwong@ea.com',
  'izabela.achmatow@huuugegames.com',
  'izabela.byrska@huuugegames.com',
  'j.hansen@astragon.de',
  'j.kuhlmann@astragon.de',
  'j.levy@draftkings.com',
  'j.valenza@draftkings.com',
  'jacek.kwiatkowski@huuugegames.com',
  'james@dirtybit.no',
  'james@greenstone.games',
  'jan.kuhlmann@astragon.de',
  'jari@dodreams.com',
  'jasmin.kaesser@swr.de',
  'jcavenagh@ea.com',
  'jeff.eldridge@liquidandgrit.com',
  'jeroen.coessens@ubisoft.com',
  'jhouston@critpath.com',
  'jim.green@onepeloton.com',
  'jmowens@critpath.com',
  'jochen.gary@stillfront.com',
  'josephine@nightmarket.games',
  'jovana.petrovic@playstudios-il.com',
  'joy@nightmarket.games',
  'jscoggins@ea.com',
  'jukka.hilvonen@huuugegames.com',
  'julia.maroto@metacoregames.com',
  'jussi.naapuri@metacoregames.com',
  'kacper.chwalinski@huuugegames.com',
  'kari.silvennoinen@ubisoft.com',
  'karina.guiliano@g5.com',
  'karolina.ziobrowska-ext@stillfront.com',
  'kat@extradimension.games',
  'kat@makeandmodel.ca',
  'katarzyna.marques-david@huuugegames.com',
  'katharina.heiler@westwing.de',
  'katriina@dirtybit.com',
  'keith.mccormic@liquidandgrit.com',
  'kevin.messer@sony.com',
  'kevin.r@millionvictories.com',
  'kevin@millionvictories.com',
  'kevink@playstudios.com',
  'kirill.rostovtsev@g5.com',
  'kit@lootlabs.xyz',
  'klegeyt@ea.com',
  'kobi.gur@huuugegames.com',
  'kristin.hoehn@cdm.lu',
  'kristoffer@firebirdgames.com',
  'kritigames.am@legodigitalplay.com',
  'kritigames.zr@legodigitalplay.com',
  'lasse.rodeck@stillfront.com',
  'laura.borges@cdm.lu',
  'lena@cozygamestudio.com',
  'lfrager@zynga.com',
  'linda.jakobsson@metacoregames.com',
  'louis.vo@ea.com',
  'lplaev@zynga.com',
  'lucian.munteanu@stillfront.com',
  'ludovic@millionvictories.com',
  'machan@ea.com',
  'maedwards@ea.com',
  'magdalena.mularczyk@huuugegames.com',
  'magdalena.sumowska@huuugegames.com',
  'maggy.katz@huuugegames.com',
  'magnus@1939games.com',
  'main@arcaneblast.com',
  'manav.chhuneja@zynga.com',
  'maral@trailmixgames.com',
  'marc@nightmarket.games',
  'marcin.grynkiewicz@huuugegames.com',
  'marcus@cultofthenorth.com',
  'marek.pasieczny@huuugegames.com',
  'maren@nextlotto.de',
  'marinelle@playstudios.com',
  'marisa@polyarcgames.com',
  'martin@dodreams.com',
  'matija.surina@nanobit.com',
  'matownsend@ea.com',
  'matt.hood@trailmixgames.com',
  'matt@bw.games',
  'matteo.posanzini@stillfront.com',
  'matthew@dirtybit.no',
  'max@extradimension.games',
  'may.song@zynga.com',
  'megoldberg@zynga.com',
  'mhw@legodigitalplay.com',
  'michal.kundera@huuugegames.com',
  'michele.martani@legodigitalplay.com',
  'mickey@playstudios.com',
  'miia.enroth@metacoregames.com',
  'mika@1939games.com',
  'mikael.kitola@dodreams.com',
  'mingxia@meta.com',
  'mira.sallanko@metacoregames.com',
  'mlaub@ea.com',
  'mopie@ea.com',
  'mor.hasson@playstudios-il.com',
  'morgane@klang-games.com',
  'mshonkoff@draftkings.com',
  'muriel@playstudios-il.com',
  'mzukoff@draftkings.com',
  'n.gooding@draftkings.com',
  'nathalie@trailmixgames.com',
  'nazar.glinskiy@g5.com',
  'nejeed@rewiredtx.com',
  'nenad@bozzystudios.com',
  'niina.fujioka@playableworlds.com',
  'nikki@nightmarket.games',
  'nils.toellner@stillfront.com',
  'nina.mueller@stillfront.com',
  'njackson@zynga.com',
  'nread@popcap.com',
  'nreinhart@ea.com',
  'nwi@legodigitalplay.com',
  'o.mansur@plaion.com',
  'ohad.russo@playstudios-il.com',
  'olaf.rauland@stillfront.com',
  'olga.snetkova@g5.com',
  'oliver@maintainaltitude.com',
  'oran.martin@playstudios-il.com',
  'pamela.iluore@sony.com',
  'patryk.batko.b@gmail.com',
  'paul.nowak@stillfront.com',
  'pauline@millionvictories.com',
  'pavel@nebulae.world',
  'pavla.muzikova@criticalforce.fi',
  'pawel.gruszowski@huuugegames.com',
  'payton.millikin@liquidandgrit.com',
  'pedram@nightmarket.games',
  'peter@firebirdgames.com',
  'phil.carpenter@naturalmotion.com',
  'philip.culleton@stillfront.com',
  'philippa@trailmixgames.com',
  'piyush.dhaniwal@sony.com',
  'r.gale@plaion.com',
  'rachel.darshan@metacoregames.com',
  'ran.keren@playstudios-il.com',
  'raph@playableworlds.com',
  'raphaela.schilling@westwing.de',
  'rashad.hasanli@dienogames.com',
  'rasmus.roar.hansen@kirkbi.com',
  'renan.ovali@metacoregames.com',
  'rhys.waters97@gmail.com',
  'rodolfo.rinaldi@huuugegames.com',
  'romain@millionvictories.com',
  'ron.finkelstein@playstudios-il.com',
  'rotem.yarkoni@playstudios-il.com',
  'rrh@legodigitalplay.com',
  'rufus.tornquist@stillfront.com',
  'ryan.moser@playstudios.com',
  'ryan.pham@playstudios.asia',
  'sabine.heyne@metacoregames.com',
  'sander@dirtybit.no',
  'sanjit.singh@ubisoft.com',
  'sbeattie@ea.com',
  'scott.macdonald@liquidandgrit.com',
  'scott@lootlabs.xyz',
  'scottc@playstudios.com',
  'sdrury@draftkings.com',
  'sean@extradimension.games',
  'selina.springvloet@fortisgames.com',
  'sergiy@cultofthenorth.com',
  'shahar.david@innogames.com',
  'shannon.woods@ea.com',
  'shuhei.watanabe@metacoregames.com',
  'simo.rajamaki@cosmicloungegames.com',
  'simon@maintainaltitude.com',
  'sluxi@tiltingpoint.com',
  'sofiia.naboka@huuugegames.com',
  'soham.dave@stillfront.com',
  'spattom@ea.com',
  'spolyakov@scorewarrior.com',
  'stefanjd@nordeus.com',
  'stephen.reponen@metacoregames.com',
  'steve.porter@metacoregames.com',
  'suman.majety@stillfront.com',
  'supatil@ea.com',
  'svenja.schnier@stillfront.com',
  'szczepan.nowak@huuugegames.com',
  'tadeusz.ambroziak@huuugegames.com',
  'tcarou@zynga.com',
  'tchakraborty@zynga.com',
  'tdequidt@zynga.com',
  'thomas.marcon_contract@playableworlds.com',
  'thomas@1939games.com',
  'tiavina@millionvictories.com',
  'tito.mutunga@zynga.com',
  'tlander@ea.com',
  'tmatheson@critpath.com',
  'tmcgeathy@seekergames.com',
  'tobias.birowicz@stillfront.com',
  'tomr@formation.games',
  'tony.trinh@playstudios.asia',
  'trainio@zynga.com',
  'tstefanowicz@zynga.com',
  'tuomas@1939games.com',
  'val@co-creategames.com',
  'valeryia.haurylavets-ext@stillfront.com',
  'vanessa.gloeckler@stillfront.com',
  'varia.bejgier@metacoregames.com',
  'veli-matti.hokkanen@metacoregames.com',
  'veronica.alvarado@playstudios.com',
  'vignon.zinsou@sony.com',
  'vijay.sudalaimuthu@stillfront.com',
  'vincent.villaume@stillfront.com',
  'volkan@harmonygames.co',
  'volodymyr.kurshynov@huuugegames.com',
  'vr@eve-co.uk',
  'vtl@legodigitalplay.com',
  'wangning1020@outlook.com',
  'william.nunes@metacoregames.com',
  'yevheniia.nikitenko@huuugegames.com',
  'yoojin@trailmixgames.com',
  'youngseok.lee@stillfront.com'
];

// Bytro Labs, marked Unsure with the note "Remove access to Navigator / Traits.
// They have Elaris access - keep that": this page closes only the dashboard
// (Traits and Navigator), so Elaris stays theirs.
export const DASHBOARD_ONLY_REMOVED_EMAILS: string[] = [
  'aadith.krishna@bytro.com',
  'andrea.falzon-garrett@stillfront.com',
  'christian.godorr@bytro.com',
  'christian.hollaender@stillfront.com',
  'daniel.barbadillo@doradogames.com',
  'david.akompian@bytro.com',
  'david.westerman-ferreira@bytro.com',
  'doga.ilktac@stillfront.com',
  'dylan@doradogames.com',
  'elena.blazhevska@stillfront.com',
  'elena.falzon-garrett@stillfront.com',
  'elena@doradogames.com',
  'erdem.alpkaya@bytro.com',
  'felix.schroeter@bytro.com',
  'gabriel.canavarro@bytro.com',
  'garrett@doradogames.com',
  'george.laskowsky@stillfront.com',
  'jan-michel.saaksmeier@bytro.com',
  'jan-yves.josten@stillfront.com',
  'julian.werner@bytro.com',
  'kressel.rodrigues@bytro.com',
  'linus.otten@bytro.com',
  'marcell.toth@stillfront.com',
  'mark@doradogames.com',
  'markus.schuessler@bytro.com',
  'markus.schuessler@stillfront.com',
  'noah.sultana@stillfront.com',
  'renato.civadelic@doradogames.com',
  'robert.gatt@doradogames.com',
  'ronaldo.coimbra@bytro.com',
  'ronaldo.coimbra@stillfront.com',
  'sebastian.teuber@bytro.com',
  'shaun.camilleri@stillfront.com',
  'shaun@doradogames.com',
  'silvio.bohra@bytro.com',
  'slav.senkiv@bytro.com',
  'st.jitendra.oza@stillfront.com',
  'tobias.weber@stillfront.com',
  'yeti@doradogames.com'
];
